import { Alert, Slide, Snackbar } from '@mui/material';
import React from 'react';
import { createRoot } from 'react-dom/client';

type MessageType = 'success' | 'error' | 'info' | 'warning';

interface NotifyProps {
  message: string,
  type: MessageType,
}

const NotificationSnackbar: React.FC<NotifyProps> = (props) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={6000}
      TransitionComponent={Slide}
      transitionDuration={{ enter: 1000, exit: 2000 }}
      TransitionProps={{ enter: true, exit: false }}
      open={true}
      sx={{ '&.MuiSnackbar-root': { top: '100px' } }}
    >
      <Alert
        severity={props.type}
        variant="filled"
        sx={{ width: '100%', fontSize: 20, "& .MuiAlert-icon": { fontSize: 28} }}
      >
        {props.message}
      </Alert>
    </Snackbar>
  );
};

const showNotification = ({ message, type }: NotifyProps) => {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const root = createRoot(container);
  root.render(<NotificationSnackbar message={message} type={type} />);

  setTimeout(() => {
    document.body.removeChild(container);
  }, 5000);
};

export default showNotification;